import { createCommand, type LexicalCommand } from "lexical";

/**
 * Opens the link field for the selected text, as Mod+K does. Whoever draws that field handles it;
 * a control elsewhere (the composer's toolbar) only asks. Not handled without text selected.
 */
export const OPEN_LINK_EDITOR_COMMAND: LexicalCommand<void> = createCommand(
  "z-editor/OPEN_LINK_EDITOR",
);
